import type { Participant } from "@zoom/videosdk";
import type { RemoteAudioDelegator } from "../../../../core/room/participant/media/MediaDelegator";
import {
  MediaSource,
  QualityMode,
} from "../../../../core/room/participant/media/types";

/**
 * Extracts video concerns from Zoom's monolithic Participant into granular objects
 * that our system expects. Unlike Twilio's separate track objects, Zoom bundles
 * audio/video concerns in a single participant.
 *
 * This delegator isolates the audio functionality to maintain existing functionality.
 */
export class ZoomRemoteAudioDelegator implements RemoteAudioDelegator {
  readonly kind = "audio" as const;
  #participant: Participant;
  #qualityMode: QualityMode | undefined;

  constructor(participant: Participant) {
    this.#participant = participant;
    // derive a qualityMode value for Zoom audio
  }

  get sid() {
    return `${this.#participant.userId}:${this.kind}:${this.source}`;
  }

  get source() {
    // TODO: CARED-2694
    return MediaSource.Microphone;
  }

  get isEnabled() {
    const audio = this.#participant.audio;
    return audio === "computer" || audio === "phone";
  }

  get qualityMode() {
    return this.#qualityMode;
  }

  /**
   * These are no-ops because Zoom secretly attaches and detaches the <audio> element.
   * They do not expose the underlying remote audio media streams.
   */
  async attach() {
    return;
  }

  async detach() {
    return;
  }
}
